<script setup lang="ts">
import type {Populated} from '~/types/populated'
import {mobileGrid, tabletGrid, desktopGrid, lgGrid} from './cell'
import type {HomeGlobal} from '~/payload-types'

const props = defineProps<{
  data: Populated<HomeGlobal['tech']>
}>()
</script>

<template>
  <Container v-if="data" class="screen-content pointer-events-none flex flex-col items-center space-y-6 px-0 py-16">
    <div class="mb-8 flex flex-col items-center justify-center text-center">
      <Heading as="h3" size="caption" class="mb-4 flex flex-col px-10 lg:px-0">
        {{ data.headline }}
      </Heading>

      <Heading as="h2" size="large" class="mb-2 w-9/12">{{ data.title }}</Heading>

      <Paragraph size="medium" class="mb-8 w-full max-w-2xl px-8 text-gray-600 lg:px-0">
        {{ data.body }}
      </Paragraph>
    </div>

    <TechPixelGrid :pattern="desktopGrid" class="!pointer-events-auto z-0 hidden xl:grid" />
    <TechPixelGrid :pattern="lgGrid" class="!pointer-events-auto z-0 hidden lg:grid xl:hidden" />
    <TechPixelGrid :pattern="tabletGrid" class="!pointer-events-auto z-0 hidden sm:grid lg:hidden" />
    <TechPixelGrid :pattern="mobileGrid" class="!pointer-events-auto z-0 grid sm:hidden" />
  </Container>
</template>
